import { cap } from '../../State'
import { translations } from '../../translations'

const t = translations[cap.language.state || 'IT'] || translations.IT

/**
 * Costanti condivise dalla pagina Statistiche.
 * Label, colori e flag per le card e le barre di percentuale.
 */
export const LABEL_STATISTICS = [
  { label: 'errorHandled', color: '#2563eb', main: true },
  { label: 'elaborated', color: '#14a06b', main: true },
  { label: 'handlerCorrectNora', color: '#14a06b', main: true },
  { label: 'trasfertaConversations', color: 'green' },
  { label: 'openPauseConversation', color: '#39c3b4' },
  { label: 'ignoredConversation', color: 'yellow' },
  { label: 'handledByOperator', color: 'orange' },
  { label: 'realError', color: 'red', error: true },
  { label: 'noraIsExcluded', color: '#d92d2d', error: true },
  { label: 'errorTotal', color: '#d92d2d', error: true }
]

/** Costo per singola conversazione (€) */
export const COSTO_PER_CONVERSAZIONE = 0.2

/**
 * Preset per la selezione rapida del periodo date nella dashboard.
 * Ogni preset espone getRange() che restituisce { start: Date, end: Date }.
 */
export const DATE_PRESETS = [
  {
    label: t.stPresetOggi,
    getRange: () => {
      const today = new Date()
      return { start: today, end: today }
    }
  },
  {
    label: t.stPreset7Giorni,
    getRange: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      return { start, end }
    }
  },
  {
    label: t.stPreset30Giorni,
    getRange: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return { start, end }
    }
  },
  {
    label: t.stPresetQuestoMese,
    getRange: () => {
      const now = new Date()
      return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: now }
    }
  },
  {
    label: t.stPreset3Mesi,
    getRange: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 3)
      return { start, end }
    }
  },
  {
    label: t.stPresetAnno,
    getRange: () => {
      const now = new Date()
      return { start: new Date(now.getFullYear(), 0, 1), end: now }
    }
  }
]

/** Opzioni per il filtro stato conversazione */
export const STATUS_OPTIONS = [
  { id: '', name: t.allStates },
  { id: 'open', name: t.stStatusAperta },
  { id: 'ended', name: t.stStatusTerminata },
  { id: 'error', name: t.errore },
  { id: 'handledByOperator', name: t.stStatusGestitaOperatore },
  { id: 'paused', name: t.inAttesaDiConferma },
  { id: 'canceled', name: t.cancellata },
  { id: 'ignored', name: t.ignorata }
]
